<div class="modal fade" [class.show]="visible" [style.display]="visible ? 'block' : 'none'" tabindex="-1" role="dialog" aria-labelledby="templateLoadModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="templateLoadModalLabel">
          <i class="fas fa-layer-group me-2"></i>
          Carica Template
        </h5>
        <button type="button" class="btn-close" (click)="onCancel()" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <!-- Filtri -->
        <div class="row mb-4">
          <div class="col-md-8">
            <div class="input-group">
              <span class="input-group-text">
                <i class="fas fa-search"></i>
              </span>
              <input type="text" class="form-control" placeholder="Cerca template per nome o descrizione..." [(ngModel)]="searchTerm" (input)="onSearchChange()" />
            </div>
          </div>
          <div class="col-md-4">
            <select class="form-select" [(ngModel)]="selectedType" (change)="onTypeChange()">
              <option value="">Tutti i tipi</option>
              <option value="structure_only">Solo Struttura</option>
              <option value="with_content">Con Contenuto</option>
            </select>
          </div>
        </div>

        <!-- Loading -->
        @if (loading()) {
          <div class="d-flex justify-content-center py-4">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Caricamento...</span>
            </div>
          </div>
        }

        <!-- Lista Template -->
        @if (!loading() && templates().length > 0) {
          <div class="row">
            @for (template of templates(); track template.id) {
              <div class="col-md-6 mb-3">
                <div class="card template-card h-100" [class.selected]="selectedTemplate()?.id === template.id" (click)="selectTemplate(template)">
                  <div class="card-body">
                    <div class="d-flex justify-content-between align-items-start mb-2">
                      <h6 class="card-title mb-0">{{ template.name }}</h6>
                      <span class="badge" [class]="getTypeBadgeClass(template.type)">
                        {{ getTypeLabel(template.type) }}
                      </span>
                    </div>

                    @if (template.description) {
                      <p class="card-text text-muted small mb-2">{{ template.description }}</p>
                    }

                    <div class="d-flex justify-content-between align-items-center">
                      <small class="text-muted">
                        <i class="fas fa-calendar me-1"></i>
                        {{ formatDate(template.createdAt) }}
                      </small>
                      <div class="btn-group btn-group-sm">
                        <button type="button" class="btn btn-outline-secondary" (click)="onDuplicate(template, $event)" title="Duplica template">
                          <i class="fas fa-copy"></i>
                        </button>
                        <button type="button" class="btn btn-outline-danger" (click)="onDelete(template, $event)" title="Elimina template">
                          <i class="fas fa-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        }

        <!-- Nessun template -->
        @if (!loading() && templates().length === 0) {
          <div class="text-center py-4">
            <i class="fas fa-layer-group fa-3x text-muted mb-3"></i>
            <h6 class="text-muted">Nessun template trovato</h6>
            <p class="text-muted mb-0">
              @if (searchTerm || selectedType) {
                Prova a modificare i filtri di ricerca.
              } @else {
                Crea il tuo primo template salvando un layout dall'editor.
              }
            </p>
          </div>
        }
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">Annulla</button>
        <button type="button" class="btn btn-primary" [disabled]="!selectedTemplate() || actionLoading()" (click)="onLoad()">
          @if (actionLoading()) {
            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          }
          <i class="fas fa-download me-2"></i>
          Carica Template
        </button>
      </div>
    </div>
  </div>
</div>

@if (visible) {
  <div class="modal-backdrop fade show"></div>
}

<!-- Modale di conferma caricamento -->
<div class="modal fade" [class.show]="showConfirmModal" [style.display]="showConfirmModal ? 'block' : 'none'" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-exclamation-triangle text-warning me-2"></i>
          Conferma Caricamento
        </h5>
      </div>
      <div class="modal-body">
        <p class="mb-3"><strong>Attenzione!</strong> Caricando questo template, tutto il contenuto attuale dell'editor verrà sostituito.</p>
        <p class="mb-0">Sei sicuro di voler continuare?</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="cancelLoad()">Annulla</button>
        <button type="button" class="btn btn-warning" (click)="confirmLoad()">
          <i class="fas fa-check me-2"></i>
          Sì, Carica Template
        </button>
      </div>
    </div>
  </div>
</div>
